export default __webpack_public_path__ + "static/media/bg-sidebar.9f5de2a8.svg";